import { render, staticRenderFns } from "./GastroEnteroscopiaView.vue?vue&type=template&id=aaeb2950"
import script from "./GastroEnteroscopiaView.vue?vue&type=script&lang=js"
export * from "./GastroEnteroscopiaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports